import type { NavigationGuardNext, RouteLocationNormalizedLoaded, RouteRecordRaw } from 'vue-router';

import { AccessDeniedRouteError, convertMaybeErrorToRouteError } from '@/core/lib/RouterUtils';
import { RouteName } from '@/core/router/RouteName';
import { getAuthentication } from '@/plugins/authentication/lib/Authentication';
import { getDocumentToDownload } from '@/plugins/documentation/lib/DocumentApi';

const beforeEnterTelecharger = async (
  to: RouteLocationNormalizedLoaded,
  from: RouteLocationNormalizedLoaded,
  next: NavigationGuardNext,
) => {
  try {
    const document = await getDocumentToDownload(to.params.id as string);

    if (!document.isPublic) {
      const { authenticated } = await (await getAuthentication()).authenticate();

      if (!authenticated) {
        next(new AccessDeniedRouteError());

        return;
      }
    }

    next();

    return;
  } catch (e) {
    next(convertMaybeErrorToRouteError(e));

    return;
  }
};

const routes: readonly RouteRecordRaw[] = [
  {
    name: RouteName.DOCUMENTATION,
    path: '/documentation',
    component: () => import('@/domains/documentation/views/HomePage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: RouteName.DOCUMENTATION_SEARCH,
    path: `/documentation/recherche`,
    component: () => import('@/domains/documentation/views/SearchPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: RouteName.DOCUMENTATION_DOWNLOAD,
    path: `/documentation/telecharger/:id`,
    component: () => import('@/domains/documentation/views/DownloadPage.vue'),
    props: true,
    beforeEnter: beforeEnterTelecharger,
  },
];

export default routes;
